<app-offcanvas-base [returnUrl]="returnUrl()">
  <ng-container title>{{ title }}</ng-container>
  <ng-container body>
    <div class="row align-items-center">
      <ng-content select="[heading]"></ng-content>
      <div class="col-auto">
        <app-status-badge
          [value]="cardDetailDisplay().status"
          [department]="statusBadgeDepartments.CARDS"></app-status-badge>
      </div>
    </div>
    <div class="my-5">
      @if (isOwner() && isActiveCard()) {
        <app-virtual-card [cardType]="cardDetailDisplay().type"></app-virtual-card>
      } @else {
        <app-virtual-card-static [cardDetail]="cardDetailDisplay()"></app-virtual-card-static>
      }
    </div>
    <div class="mb-5">
      <ng-content select="[cardholderDetails]"></ng-content>

      @if (!isBlockedCard() && !isRemovedCard()) {
        <div class="text-muted">Card balance:</div>
        <p class="fs-3 fw-bold">
          {{ cardBalance().balance | currency: 'ZAR' : 'symbol-narrow' | emptyIndicator: 'N/A' }}
        </p>
      }

      @if (isBlockedCard() || isRemovedCard()) {
        <div class="mt-3">
          <div class="h4"></div>
          <div class="card card-sm border-secondary">
            <div class="card-body">
              @if (isBlockedCard()) {
                <p class="text-muted mb-1">Card has been blocked because:</p>
                <p class="fw-semibold">
                  @if (cardDetailDisplay().block?.block_reason === CardBlockReason.Fraud) {
                    Suspected Fraud
                  }
                  @if (cardDetailDisplay().block?.block_reason === CardBlockReason.Lost) {
                    Card has been lost
                  }
                  @if (cardDetailDisplay().block?.block_reason === CardBlockReason.Stolen) {
                    Card has been stolen
                  }
                  @if (cardDetailDisplay().block?.block_reason === CardBlockReason.Other) {
                    {{ cardDetailDisplay().block?.block_reason_other }}
                  }
                </p>
                <hr />
              }
              <p>{{ isBlockedCard() ? 'Blocked' : 'Removed' }} by:</p>

              @if (isBlockedCard()) {
                @if (cardDetailDisplay().block) {
                  <ng-container
                    [ngTemplateOutlet]="employeeDetails"
                    [ngTemplateOutletContext]="{ $implicit: cardDetailDisplay().block }"></ng-container>
                } @else {
                  <em class="text-muted">No employee details available</em>
                }
              }
              @if (isRemovedCard()) {
                @if (cardDetailDisplay().remove) {
                  <ng-container
                    [ngTemplateOutlet]="employeeDetails"
                    [ngTemplateOutletContext]="{ $implicit: cardDetailDisplay().remove }"></ng-container>
                } @else {
                  <em class="text-muted">No employee details available</em>
                }
              }
              <ng-template
                #employeeDetails
                let-employeeData>
                <div class="row align-items-center">
                  <div class="col">
                    <div class="row align-items-center">
                      <div class="col-auto">
                        <app-avatar
                          [firstName]="employeeData.employee?.first_name"
                          [lastName]="employeeData.employee?.last_name"
                          size="md"></app-avatar>
                      </div>
                      <div class="col">
                        <div class="text-muted">Employee</div>
                        {{ employeeData.employee?.first_name }}
                        {{ employeeData.employee?.last_name }}
                      </div>
                    </div>
                  </div>
                  <div class="col">
                    <div class="text-muted">Date {{ isBlockedCard() ? 'blocked' : 'removed' }}:</div>
                    @if (employeeData?.created) {
                      {{ employeeData?.created | date: 'dd MMM yyyy HH:mm' }}
                    }
                    @if (employeeData?.block_at) {
                      {{ employeeData?.block_at | date: 'dd MMM yyyy HH:mm' }}
                    }
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      }
    </div>
    <div class="row gy-3 offcanvas-buttons">
      <div class="col-12 col-sm-auto">
        @if (isSubscriptionCard()) {
          @if (!isRemovedCard()) {
            <button
              class="btn btn-outline-dark"
              (click)="goToRemoveCard()">
              Remove card
            </button>
          }
        }
      </div>
      <div class="col-12 col-sm-auto ms-auto">
        @if (isActiveCard()) {
          <button
            (click)="goToBlockCard()"
            class="btn btn-primary">
            Block card
          </button>
        }
        @if (isBlockedCard() && isReasonOther()) {
          <button
            class="btn btn-primary"
            (click)="onUnblockCard()">
            Unblock card
          </button>
        }
        @if (isBlockedCard() && !isReasonOther()) {
          <button
            (click)="goToReplaceCard()"
            class="btn btn-primary ms-3">
            Replace card
          </button>
        }
      </div>
    </div>
  </ng-container>
</app-offcanvas-base>
